// Site-based terminology: sales-profile sites talk about "Deals",
// non-sales functions (accounts, support, management, IT…) about "Opps",
// the AI Agent site about "Follow-ups". Unrecognised sites (e.g. gym clubs
// or showrooms) fall back to the tenant's industry default.
export const revivableTerm = (site, fallback = 'Opp') => {
  const s = (site || '').toLowerCase();
  if (/(telemarket|sales|b2b)/.test(s)) return 'Deal';
  if (/ai[\s-]?agent/.test(s)) return 'Follow-up';
  if (/(account|management|support|unassigned|admin|helpdesk|reception|queue)/.test(s)) return 'Opp';
  return fallback;
};

export const TERM_CHIP_STYLE = {
  Deal: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Opp: 'bg-sky-50 text-sky-700 border-sky-200',
  'Follow-up': 'bg-violet-50 text-violet-700 border-violet-200',
};
